import Aos from 'aos'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  useEffect(() => {
    Aos.init({ once: true }); 

    setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);})
  return (
    <>
      <footer className='flex items-end justify-center border-t border-solid border-gray-200_01 py-5'>
        <div className="mx-auto mt-5 flex w-full max-w-6xl justify-center xl:px-0 px-5">
          <div className="flex w-full flex-col items-center gap-5">
            <p className=' text-[12px] font-normal text-gray-600_01'>© 2025 SEDACKANAKAZDODENNESPANIE.SK</p>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer
